// src/frontend/src/pages/PricingPage.tsx
import React from 'react';
import Layout from '../components/Layout/Layout';
import PricingContent from '../components/Pricing/PricingContent';

const PricingPage: React.FC = () => {
  return (
    <Layout>
      <PricingContent 
        showFullFAQ={true} 
        showBillingToggle={true}
      />
    </Layout>
  );
};

export default PricingPage;
